import * as accounts from '@planningcenter/icons/paths/accounts'
import * as api from '@planningcenter/icons/paths/api'
import * as brand from '@planningcenter/icons/paths/brand'
import * as calendar from '@planningcenter/icons/paths/calendar'
import * as cco from '@planningcenter/icons/paths/cco'
import * as churchCenter from '@planningcenter/icons/paths/church-center'
import * as general from '@planningcenter/icons/paths/general'
import * as giving from '@planningcenter/icons/paths/giving'
import * as groups from '@planningcenter/icons/paths/groups'
import * as people from '@planningcenter/icons/paths/people'
import * as publishing from '@planningcenter/icons/paths/publishing'
import * as registrations from '@planningcenter/icons/paths/registrations'

export const icons = {
  accounts,
  api,
  brand,
  calendar,
  cco,
  churchCenter,
  general,
  giving,
  groups,
  people,
  publishing,
  registrations,
}
